import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import posthog from "posthog-js";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddUserModal = ({ open, setOpen, setOpenUserInvitedModal, users, setUsers, planDetails,fetchUsers, loader, setLoader }) => {
  const [channel, setChannel] = useState({
    channel_type: "email",
  });


  const navigate = useNavigate()


  const[user, setUser] = useState({
    email: null,
    password: '1234',
    first_name: null,
    last_name: null,
    type: 'admin',
    org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    organization_name:JSON.parse(localStorage.getItem("organization")).organization_name.S
  })


  const [errorMsg, setErrorMsg] = useState(null);


  const createUser = async () => {
    setLoader(true);
    let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
            userId: JSON.parse(localStorage.getItem('user')).userId.S
        });
        
        if (check.status === 200) {
          const user___ = check.data.user;
          
    
          if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)){
               try {
                 
                 console.log(user)
           
                 let user_data = await axios
                 .post(
                   process.env.REACT_APP_BACKEND_URL + "user/create-user-without-org",
                   user
                 )
                 console.log(user_data)
           
                //  let relatedOrgs = await axios .post(
                //    process.env.REACT_APP_BACKEND_URL + "add-related-org",
                //    {
                //      user_id : user_data.data.user.userId.S,
                //      organization_name: user.organization_name ,
                //      organization_id : user.org_id
                //    }
                //  )
                //  console.log(user_data)
           
           
                 let add_user = await axios
                 .post(
                   process.env.REACT_APP_BACKEND_URL + "add-user",
                   {
                     user_id : user_data.data.user.userId.S,
                     status: 'pending',
                     type: user.type,
                     organization_id : user.org_id
                   }
                 )
           
                 localStorage.setItem('organization',JSON.stringify(add_user.data.updatedItem))
                 console.log(add_user)
           
                 setOpen(false)
               
           
             
                
                
           
           
                 //send invite email
           
                 let invite = await axios
                 .post(
                   process.env.REACT_APP_BACKEND_URL + "email/send-invite",
                   {email: user.email, toName: user.first_name+' '+user.last_name, invite_url:`${process.env.REACT_APP_FRONTEND_URL}accept-invite/${add_user.data.encrypted_code}`
                     , org_name: JSON.parse(localStorage.getItem("organization")).organization_name.S }
                 )
                 console.log(invite)
                 setOpenUserInvitedModal(true)
                 posthog.capture('Added a user', {
                  email: JSON.parse(localStorage.getItem('user')).email.S,
            userId : JSON.parse(localStorage.getItem('user')).userId.S,
                });
                 setUser(
                   {
                     email: null,
                     password: '1234',
                     first_name: null,
                     last_name: null,
                     type: 'admin',
                     org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                     organization_name:JSON.parse(localStorage.getItem("organization")).organization_name.S
                   }
                 )
           
                 setLoader(false)
                 setUsers((prevUsers) => [
                   ...prevUsers,
                   {
                     name: `${user_data.data.user.fName.S} ${user_data.data.user.lName.S}`,
                     email: user_data.data.user.email.S,
                     userType: user.type, // Extract userType from the input
                     status: 'pending', // Default status as 'pending'
                     user_id: user_data.data.user.userId.S, // Extract userId
                   },
                 ]);
           
                 fetchUsers()
           
               } catch (error) {
                 console.log(error);
                 if (error.response && error.response.data) {
                   console.error("Response data:", error.response.data);
                   setErrorMsg(error.response.data.message);
                 }
                 setLoader(false);
               }
          }else{
            window.location.reload()
          }

        }
  };
  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"}
    BackdropProps={{
      style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
    }}
    >
      <div className="lg:px-8 px-4 py-6">
        
      {(planDetails && planDetails.team_members <= users.length) && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "" }} /> 
          You are already using 1 seat out of the 1 seats available on your plan. 
        <a className="cursor-pointer hover:underline text-blue-800" onClick={()=> {navigate('/dashboard/settings/billing')}}> Upgrade plans</a> or <a className="cursor-pointer hover:underline text-blue-800" href='mailto:hello@twilanswer.com' >contact support</a> to add more seats.
        </div>
      )}

      {errorMsg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
        </div>
      )}

        <div className="lg:text-[16px]  text-[15px] font-semibold mb-4"> Add User</div>
        <div className="flex justify-center">
          <div className="lg:space-y-5 space-y-3">
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 lg:space-y-0 space-y-2">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                User Type{" "}
              </div>

              <div className="lg:w-[300px] w-full">
                <Select
                  IconComponent={KeyboardArrowDown}
                  fullWidth
                  defaultValue={user.type}
                  value={user.type}
                  onChange={(e) => {
                    setUser({ ...user, type: e.target.value });
                  }}
                  className="mb-2 bg-[#F7F7F8]"
                  sx={{
                    fontSize: "14px",
                    padding: "4px 8px", // Adjust padding here
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "4px 8px", // Adjust padding for the text inside Select
                    },
                  }}
                >
                  <MenuItem value="admin">Admin</MenuItem>
                  <MenuItem value="user">User</MenuItem>
                  <MenuItem value="owner">Owner</MenuItem>
                </Select>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 lg:space-y-0 space-y-2">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                Name 
              </div>

              <div className="lg:w-[300px] w-full flex items-center space-x-4">
                <InputBase
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    fontSize: "14px",
                  }}
                  value={user.first_name}
                  onChange={(e) => {
                    setUser({ ...user, first_name: e.target.value });
                  }}
                />

                <InputBase
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    fontSize: "14px",
                  }}

                  value={user.last_name}
                  onChange={(e) => {
                    setUser({ ...user, last_name: e.target.value });
                  }}
                />
              </div>
            </div>
              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 lg:space-y-0 space-y-2">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Email Address
                </div>

                <div className="lg:w-[300px] w-full">
                  <InputBase
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      fontSize: "14px",
                    }}

                    value={user.email}
                  onChange={(e) => {
                    setUser({ ...user, email: e.target.value });
                  }}
                  />
                </div>

              </div>
            

            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: {lg:"14px", xs:"13px"},
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Close
              </Button>

              {(planDetails && planDetails.team_members <= users.length) ? (
                 <Button
                 sx={{
                   textTransform: "none",
                   bgcolor: "#605BFF",
                   color: "white",
                   py: "4px",
                   px: "40px",
                   borderRadius: "7px",
                   fontSize: {lg:"14px", xs:"13px"},
                 }}
 
                 onClick={()=>{
                   
                   navigate('/dashboard/settings/billing')
                 }}
                 
                 disabled={loader}
               >
                 {loader? (
                           <CircularProgress
                             size={"1.3rem"}
                             sx={{ color: "white" }}
                           />
                         ) : (
                           " Upgrade Plan"
                         )}
               </Button>
              ) : (
                 <Button
                 sx={{
                   textTransform: "none",
                   bgcolor: "#605BFF",
                   color: "white",
                   py: "4px",
                   px: "40px",
                   borderRadius: "7px",
                   fontSize: {lg:"14px", xs:"13px"},
                 }}
 
                 onClick={()=>{
                   
                   createUser()
                 }}
                 disabled={loader}
               >
                 {loader? (
                           <CircularProgress
                             size={"1.3rem"}
                             sx={{ color: "white" }}
                           />
                         ) : (
                           " Save"
                         )}
               </Button>
              )}

             
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddUserModal;
